import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, App } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ImageProvider } from '../../providers/image';
import { LoadingProvider } from '../../providers/loading';
import { DataProvider } from '../../providers/data';
import { AlertProvider } from '../../providers/alert';
import { UserProvider } from '../../providers/user';
import { Validator } from '../../validator';
import { Camera } from '@ionic-native/camera';
import { GroupPage } from '../group/group';
import { Settings } from '../../settings';

@Component({
  selector: 'page-new-group',
  templateUrl: 'new-group.html'
})
export class NewGroupPage {
  private group: any;
  private groupForm: FormGroup;
  private friends: any;
  private searchFriend: any;
  private groupMembers: any;
  private alert: any;
  private myUserId: any;
  // NewGroupPage
  // This is the page where the user can start a new group chat with their friends.
  constructor(public navCtrl: NavController, public navParams: NavParams, public imageProvider: ImageProvider, public dataProvider: DataProvider, public formBuilder: FormBuilder, public userProvider: UserProvider,
    public alertProvider: AlertProvider, public alertCtrl: AlertController, public app: App, public loadingProvider: LoadingProvider, public camera: Camera) {
    // Create our groupForm based on Validator.ts
    this.groupForm = formBuilder.group({
      name: Validator.groupNameValidator,
      description: Validator.groupDescriptionValidator
    });
  }

  ionViewDidLoad() {
    // Initialize
    this.group = {
      img: './assets/images/default-group.png'
    };
    this.searchFriend = '';

    // Get user's friends to add to the group.
    this.dataProvider.getCurrentUser().snapshotChanges().subscribe((accountRes) => {
      let account = {$key: accountRes.key, ... accountRes.payload.val()};
      this.myUserId = accountRes.key;
      if (!this.groupMembers) {
        this.groupMembers = [account];
      }
      if(Settings.chatType == 'with-friends') {
          if (account.friends) {
              for (var i = 0; i < account.friends.length; i++) {
                  this.dataProvider.getUser(account.friends[i]).snapshotChanges().subscribe((friendRes) => {
                      if(friendRes.key != null){
                          let friend = { $key: friendRes.key, ... friendRes.payload.val()};
                          if(friendRes.key != this.myUserId) {
                              this.addOrUpdateFriend(friend);
                          }
                      }
                  });
              }
          } else {
              this.friends = [];
          }
      } else {
          this.dataProvider.getUsers().snapshotChanges().subscribe((accounts) => {
              let acc = accounts.filter( c => {
                  let m = {$key: c.key}
                  if(c.key == null && c.key == undefined && c.payload.val() == null) return false;
                  if(c.payload.val().name == '' || c.payload.val().name == ' ' || c.payload.val().name == undefined) return false;
                  if(c.payload.val().publicVisibility == false) return false;
                  if(c.key == this.myUserId) return false;
                  if(this.inGroup(m)) return false;
                  return true;
              });
              this.friends = acc.map(c=>{
                  return { $key: c.key, ...c.payload.val() }
              })
          });

          if (!this.friends) {
              this.friends = [];
          }

      }

    });
  }

  // Add or update friend for real-time sync.
  addOrUpdateFriend(friend) {
    if (!this.friends) {
      this.friends = [friend];
    } else {
      var index = -1;
      for (var i = 0; i < this.friends.length; i++) {
        if (this.friends[i].$key == friend.$key) {
          index = i;
        }
      }
      if (index > -1) {
        this.friends[index] = friend;
      } else {
        this.friends.push(friend);
      }
    }
  }

  // Back
  back() {
    if (this.group)
      this.imageProvider.deleteImageFile(this.group.img);
    this.navCtrl.pop();
  }

  // Proceed with group creation.
  done() {
    this.loadingProvider.show();
    var messages = [];
    // Add system message that group is created.
    messages.push({
      date: new Date().toString(),
      sender: this.userProvider.getUserID(),
      type: 'system',
      message: 'Die Gruppe wurde erstellt.',
      icon: 'md-chatbubbles'
    });
    // Add members of the group.
    var members = [];
    for (var i = 0; i < this.groupMembers.length; i++) {
      members.push(this.groupMembers[i].$key);
    }
    // Add group info and date.
    this.group.dateCreated = new Date().toString();
    this.group.admin = this.groupMembers[0].$key;
    this.group.messages = messages;
    this.group.members = members;
    this.group.name = this.groupForm.value["name"];
    this.group.description = this.groupForm.value["description"];
    // Add group to database.

  }

  // Add friend to members of group.
  addToGroup(friend) {
    this.groupMembers.push(friend);
  }

  // Remove friend from members of group.
  removeFromGroup(friend) {
    var index = -1;
    for (var i = 1; i < this.groupMembers.length; i++) {
      if (this.groupMembers[i].$key == friend.$key) {
        index = i;
      }
    }
    if (index > -1) {
      this.groupMembers.splice(index, 1);
    }
  }

  // Check if friend is already added to the group or not.
  inGroup(friend) {
    for (var i = 0; i < this.groupMembers.length; i++) {
      if (this.groupMembers[i].$key == friend.$key) {
        return true;
      }
    }
    return false;
  }

  // Toggle to add/remove friend from the group.
  addOrRemoveFromGroup(friend) {
    if (this.inGroup(friend)) {
      this.removeFromGroup(friend);
    } else {
      this.addToGroup(friend);
    }
  }

  isMe(user:any) {
    if(user.$key == this.myUserId)return true;
    return false;
  }
  // Set group photo.
  setGroupPhoto() {
    this.alert = this.alertCtrl.create({
      title: 'Gruppenbild ändern',
      message: 'Bild aufnehmen oder aus der Galerie auswählen?',
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => { }
        },
        {
          text: 'Aus der Galerie',
          handler: () => {
            this.imageProvider.setGroupPhoto(this.group, this.camera.PictureSourceType.PHOTOLIBRARY);
          }
        },
        {
          text: 'Aufnehmen',
          handler: () => {
            this.imageProvider.setGroupPhoto(this.group, this.camera.PictureSourceType.CAMERA);
          }
        }
      ]
    }).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/new-group/new-group.ts